import React from 'react'

export const buttonTypes = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
}

const Button = ({
  type = buttonTypes.PRIMARY,
  className = '',
  onClick = () => {},
  children,
}) => {
  switch (type) {
    case buttonTypes.PRIMARY:
      return (
        <button role="button" className={className} onClick={onClick}>
          <span className="group block border-2 border-ac-dark-gold p-2 transition active:border-ac-light-gold lg:hover:border-ac-light-gold">
            <span className="block bg-ac-light-gold px-12 pb-2 pt-2 font-din-next text-xl font-bold uppercase leading-tight tracking-widest text-ac-black transition group-active:bg-ac-dark-gold group-active:text-ac-white lg:group-hover:bg-ac-dark-gold lg:group-hover:text-ac-white">
              {children}
            </span>
          </span>
        </button>
      )
    case buttonTypes.SECONDARY:
      return (
        <button role="button" className={className} onClick={onClick}>
          <span className="block font-din-next-condensed text-2xl font-light uppercase leading-none tracking-wide text-ac-dark-gold underline underline-offset-4 transition active:text-ac-light-gold lg:hover:text-ac-light-gold">
            {children}
          </span>
        </button>
      )
    case buttonTypes.TERTIARY:
      return (
        <button role="button" className={className} onClick={onClick}>
          <span className="group block border-2 border-ac-light-gold">
            <span className="block bg-ac-light-gold p-[10px] pb-2 pt-2 text-xl font-bold uppercase leading-none tracking-widest text-ac-black transition group-active:bg-ac-dark-gold group-active:text-ac-white lg:group-hover:bg-ac-dark-gold lg:group-hover:text-ac-white">
              {children}
            </span>
          </span>
        </button>
      )
    default:
      return null
  }
}

export default Button
